import { Dialog, DialogContent, DialogTitle, DialogActions } from "@mui/material";
import CloseIcon from "../../assets/icons/close-icon-black.svg";
import { BorderSecondary, PrimaryButton } from "../../utils/muiCustomTheme";
import { DialogComponentProps } from "./DialogComponent-interface";

const DialogComponent = ({
  open,
  onClose,
  handleSubmitSecondary,
  loading,
  type = "discard",
  handleSubmitPrimary,
}: DialogComponentProps) => {
  let typeDialog: any;

  switch (type) {
    case "discard":
    case "navigate":
      typeDialog = {
        title: "Discard unsaved work?",
        desc: "You have unsaved changes. Leaving now means your edits to this item will be lost. Stay to keep editing.",
        primaryBtnLabel: "Keep editing",
        secondaryBtnLabel: "Discard",
      };
      break;
    case "required-condition":
      typeDialog = {
        title: "Warning!",
        desc: "To create and save a segment, please add at least one condition. The first section can't be empty.",
        primaryBtnLabel: "Cancel",
        secondaryBtnLabel: "",
      };
      break;
    case "total-split-under-100":
      typeDialog = {
        title: "Warning!",
        desc: "Please add at least one Audience group and make sure the total split equals 100%.",
        primaryBtnLabel: "Cancel",
        secondaryBtnLabel: "",
      };
      break;

    default:
      break;
  }

  const { title, desc, primaryBtnLabel, secondaryBtnLabel } = typeDialog || {};

  return (
    <Dialog open={open} onClose={onClose} className="general-dialog">
      <DialogTitle className="custom-dialog-title">
        <div className="view-all-attributes__title">{title}</div>
        <img className="close-icon" src={CloseIcon} alt="close icon" onClick={onClose} />
      </DialogTitle>
      <DialogContent className="dialog-download">
        <div className="dataset-sec">
          <div className="view-all-attributes__dataset-wrapper__label">{desc}</div>
        </div>
      </DialogContent>
      <DialogActions>
        {secondaryBtnLabel && (
          <BorderSecondary type="button" onClick={handleSubmitSecondary}>
            {secondaryBtnLabel}
          </BorderSecondary>
        )}

        <PrimaryButton loading={loading} variant="contained" onClick={handleSubmitPrimary}>
          {primaryBtnLabel}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default DialogComponent;
